import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import FileNotFound from '../FileNotFound';
import { modal } from '../modal/ModalEmitter';

const SearchResults = ({ onQueryClick, results, query, onSelect }) => {
  const [selected, setSelected] = useState({});
  const selectedCount = Object.keys(selected).length;

  const openEdit = customerId => {
    modal.open('loyaltyCustomerUpdate', { customerId });
  };

  // const openOffers = customerId => {
  //   modal.open('loyaltyOffers', { customerId });
  // };

  const openRedemptions = customerId => {
    modal.open('loyaltyRedemptions', { customerId });
  };

  const toggleRow = customer => {
    setSelected(customer);
  };

  const columns = [
    {
      id: 'checkbox',
      accessor: '',
      Cell: row => {
        return (
          <input
            type="checkbox"
            className="checkbox"
            checked={selected && selected.externalCustomerId === row.original.externalCustomerId}
            onChange={() => toggleRow(row.original)}
          />
        );
      },
      sortable: false,
      width: 30,
      className: 'text-center sticky',
      Header: '',
      headerClassName: 'sticky',
      show: !!onSelect, // TODO Select only used for onSelect at the moment
    },
    {
      Header: '',
      width: 100,
      className: 'text-center',
      Cell: row => {
        return (
          <ButtonGroup>
            <Button
              onClick={() => {
                openEdit(row.original.externalCustomerId);
              }}
              variant="primary"
              size="xs"
              title="Customer Information"
            >
              <i className="zmdi zmdi-edit zmdi-hc-fw" />
            </Button>
            {/* <Button
              onClick={() => {
                openOffers(row.original.externalCustomerId);
              }}
              size="xs"
              title="List Offers"
            >
              <i className="zmdi zmdi-view-list zmdi-hc-fw" />
            </Button> */}
            <Button
              onClick={() => {
                openRedemptions(row.original.externalCustomerId);
              }}
              size="xs"
              variant="success"
              title="List Redemptions"
            >
              <i className="zmdi zmdi-money-box zmdi-hc-fw" />
            </Button>
          </ButtonGroup>
        );
      },
    },
    { Header: 'CustomerID', accessor: 'externalCustomerId', className: 'text-center' },
    { Header: 'First', accessor: 'firstName' },
    { Header: 'Last', accessor: 'lastName' },
    { Header: 'Email', accessor: 'emailAddress', width: 225 },
    { Header: 'Phone', accessor: 'phoneNumber' },
    { Header: 'Company', accessor: 'company' },
    { Header: 'Preferred Dealer', accessor: 'preferredDealer' },
  ];

  const renderTbl = () => {
    if (results.length === 0) {
      return <FileNotFound>Empty</FileNotFound>;
    }

    return (
      <ReactTable
        className="-striped -highlight"
        columns={columns}
        data={results}
        showPagination={false}
        sortable
        style={{
          height: '400px',
        }}
      />
    );
  };

  useEffect(() => {
    if (results.length === 1 && onSelect) {
      setSelected(results[0]);
    }
  }, []);

  return (
    <div className="loyality-list customer-list">
      <div className="current-search" onClick={onQueryClick}>
        <span className="current-label">Query</span>
        {query.map(q => {
          return (
            <div className="search-data" key={q.label}>
              {q.value === true ? (
                <>
                  <strong>{q.label}</strong>
                </>
              ) : (
                <>
                  {q.label}: <strong>{q.value}</strong>
                </>
              )}
            </div>
          );
        })}
      </div>
      <div className="loyalty-search-results">{renderTbl()}</div>
      <div className="search-controls">
        {onSelect && (
          <Button variant="primary" onClick={() => onSelect(selected)} disabled={!selectedCount}>
            Use Selected
          </Button>
        )}
      </div>
    </div>
  );
};

SearchResults.propTypes = {
  onQueryClick: PropTypes.func,
  query: PropTypes.array, // [ { label, value } ]
  results: PropTypes.array,
  onSelect: PropTypes.func,
};

export default SearchResults;
